/**
 * The Design Book focus state for a field: a 1.5px ink border plus a 3px soft halo.
 *
 * Fields draw it themselves rather than taking the global ring, so they also carry `outline-none`.
 * Written out as whole class names on purpose - Tailwind scans source text, so a string built by
 * interpolating a variant prefix generates nothing at all.
 */
export const FOCUS_FIELD =
  'focus-visible:border-[1.5px] focus-visible:border-focus-ring focus-visible:shadow-[0_0_0_3px_var(--color-focus-halo)]';

/** The same state on a wrapper that holds the real input, so the box lights up rather than the field inside it. */
export const FOCUS_FIELD_WITHIN =
  'focus-within:border-[1.5px] focus-within:border-focus-ring focus-within:shadow-[0_0_0_3px_var(--color-focus-halo)]';
